import React, { useState } from 'react'
import messages from './messages'
import { FormattedMessage, useIntl } from 'react-intl'
import SupplierSelect from 'components/SupplierSelect'
import { Button, Input, Icon } from '@arnsbogroup/react-voicearchive'
import DateTime from 'react-datetime'

const ReportHeader = ({
    entries = [],
    loading = false,
    onSearch = () => {},
    onDownloadCsv = () => {},
    showFullTaskRow = false,
    onShowFullTaskRowChange = () => {}
}) => {
    const { formatMessage } = useIntl()
    const [searchParams, setSearchParams] = useState({
        orderId: null,
        taskId: null,
        suppliers: [],
        fromDate: null,
        toDate: null
    })

    return (
        <div className='flex gap-2 p-2'>
            <Icon className="my-auto text-primary" icon={['fa','info-circle']} title={formatMessage(messages.reportRules)}/>
            <div className='w-1/3 my-auto'>
                <Input
                    disabled={loading}
                    key='orderId'
                    defaultValue={searchParams.orderId}
                    type="number"
                    onBlur={({ target: { value } }) => setSearchParams((prev) => ({ ...prev, orderId: value }))}
                    placeholder={formatMessage(messages.orderIdPlaceholder)}
                    className="border-gray-200"
                    floatingLabel={formatMessage(messages.orderId)}
                    onKeyDown={({ key, target: { value } }) => {
                        if (key == 'Enter') {
                            setSearchParams((prev) => ({ ...prev, orderId: value }))
                        }
                    }}
                />
            </div>
            <div className='w-1/3 my-auto'>
                <Input
                    disabled={loading}
                    key='taskId'
                    defaultValue={searchParams.taskId}
                    type="number"
                    onBlur={({ target: { value } }) => setSearchParams((prev) => ({ ...prev, taskId: value }))}
                    placeholder={formatMessage(messages.taskIdPlaceholder)}
                    className="border-gray-200"
                    floatingLabel={formatMessage(messages.taskId)}
                    onKeyDown={({ key, target: { value } }) => {
                        if (key == 'Enter') {
                            setSearchParams((prev) => ({ ...prev, taskId: value }))
                        }
                    }}
                />
            </div>
            <div className='w-1/3 my-auto'>
                <DateTime
                    disabled={loading}
                    key='dateFrom'
                    onChange={(value) => setSearchParams((prev) => ({ ...prev, dateFrom: Math.round(new Date(value).getTime() / 1000) }))}
                    closeOnSelect
                    className="p-4 border border-gray-200 focus:border-primary"
                    inputProps={{
                        placeholder: formatMessage(messages.dateFrom),
                        className: "border-none"
                    }}
                />
            </div>
            <div className='w-1/3 my-auto'>
                <DateTime
                    disabled={loading}
                    key='dateTo'
                    onChange={(value) => setSearchParams((prev) => ({ ...prev, dateTo: Math.round(new Date(value).getTime() / 1000) }))}
                    closeOnSelect
                    className="p-4 border border-gray-200 focus:border-primary"
                    inputProps={{
                        placeholder: formatMessage(messages.dateTo),
                        className: "border-none"
                    }}
                />
            </div>
            <div className='w-1/3 my-auto'>
                <SupplierSelect
                    isDisabled={loading}
                    key='suppliers'
                    label={null}
                    isMulti
                    placeholder={formatMessage(messages.suppliersPlaceholder)}
                    floatingLabel={formatMessage(messages.suppliers)}
                    value={searchParams.suppliers}
                    onChange={(value) => setSearchParams((prev) => ({ ...prev, suppliers: value }))}
                />
            </div>

            <div className="flex gap-2">
                <div className='my-auto'>
                    <Button
                        onClick={() => onSearch(searchParams)}
                        size="base"
                        disabled={loading}
                    >
                        <FormattedMessage {...messages.search} />
                    </Button>
                </div>
                <div className='my-auto'>
                    <Button
                        onClick={() => onDownloadCsv()}
                        size="base"
                        variant="outline"
                        disabled={loading || !(!!entries.length)}
                    >
                        <FormattedMessage {...messages.export} />
                    </Button>
                </div>
                <div className='my-auto'>
                    <Button
                        onClick={() => onShowFullTaskRowChange()}
                        size="base"
                        variant="inline"
                        disabled={loading || !(!!entries.length)}
                    >
                        {showFullTaskRow ? (
                            <FormattedMessage {...messages.showLesserTaskRow} />
                        ) : (
                            <FormattedMessage {...messages.showFullTaskRow} />
                        )}
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default ReportHeader
